export default __webpack_public_path__ + "static/media/colmena-color.85d3ce99.svg";